import { Injectable } from '@angular/core';
import { MedicalDetails, Patient, PatientConsent, PatientSearchCriteria } from '../../../../backend/interfaces/patient.interface';
import * as Parse from 'parse';
import { BehaviorSubject } from 'rxjs';
import { CalendarEvent } from 'angular-calendar';
import { GoogleCalendarEvent } from 'backend/interfaces/calendar.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class PatientService {
  patients = new BehaviorSubject<Patient[] | null>(null);
  patients$ = this.patients.asObservable();
  patientCount = new BehaviorSubject<number | null>(null);
  patientCount$ = this.patientCount.asObservable();
  uploadToken: string;
  public newPatientEmail: string;
  constructor(private http: HttpClient) {
  }

  savePatient(patient: Patient): Promise<Patient> {
    return Parse.Cloud.run('savePatient', { patient }).then((result) => {
      return result;
    });
  }

  savePatientConsent(patientConsent: PatientConsent): Promise<Patient> {
    return Parse.Cloud.run('savePatientConsent', { patientConsent }).then((result) => {
      return result;
    });
  }

  savePatientMedicalDetails(medicalDetails: MedicalDetails): Promise<Patient> {
    return Parse.Cloud.run('savePatientMedicalDetails', { medicalDetails }).then((result) => {
      return result;
    });
  }

  getPatients(displayLimit: number, page: number): Promise<void> {
    return Parse.Cloud.run('getPatients', { displayLimit, page }).then((result) => {
      this.patients.next(result);
    });
  }

  getPatientById(id: string): Promise<Patient> {
    return Parse.Cloud.run('getPatientById', { id });
  }

  getPatientByEmail(email: string): Promise<Patient> {
    return Parse.Cloud.run('getPatientByEmail', { email });
  }

  getCalendarBusy(): Promise<any>{
    const from = "2023-01-01T00:00:00.000Z";
    const to = "2023-04-01T00:00:00.000Z";
    return Parse.Cloud.run('getCalendarBusy', { from, to });
  }

  getCalendarEvents(): Promise<any>{
    return Parse.Cloud.run('getCalendarEvents');
  }

  getPatientCount(): Promise<number>{
    return Parse.Cloud.run('getPatientCount').then((result) => {
      this.patientCount.next(result);
    });;
  }

  createBooking(event: GoogleCalendarEvent): Promise<any>{
    return Parse.Cloud.run('createBooking', { event });
  }

  updateBooking(event: GoogleCalendarEvent): Promise<any>{
    return Parse.Cloud.run('updateBooking', { event });
  }

  deleteBooking(id: string): Promise<any>{
    return Parse.Cloud.run('deleteBooking', { id });
  }

  searchPatient(criteria: PatientSearchCriteria): Promise<any>{
    return Parse.Cloud.run('searchPatient', { criteria });
  }

  saveProfilePicture(patientId: string, image: any): Promise<any>{
    return Parse.Cloud.run('saveProfilePicture', { patientId, image });
  }

  getPatientFile(id: string, mimeType: string): Promise<any>{
    return Parse.Cloud.run('getFileById', { id, mimeType })
  }

  getpatientFiles(fileId: string): Promise<any>{
    return Parse.Cloud.run('getFilesById', { fileId })
  }

  getAlbumList(id: string): Promise<any>{
    return Parse.Cloud.run('getAlbumList', { id })
  }

  getAlbumById(id: string): Promise<any>{
    return Parse.Cloud.run('getAlbumById', { id })
  }

  createDriveFolder(patientId: string): Promise<any>{
    return Parse.Cloud.run('createDriveFolder', { patientId })
  }

  createPhotoAlbum(patientId: string): Promise<any>{
    return Parse.Cloud.run('createPhotoAlbum', { patientId })
  }

  uploadFile(id: string, uploadedFile: any, description: string): Promise<any>{
    return Parse.Cloud.run('uploadFile', { id, uploadedFile, description })
  }

  async uploadPhoto(id: string, uploadedFile: any, description: string): Promise<any>{
    const authToken = await Parse.Cloud.run('getGToken', { });
    let body = uploadedFile.source;
    let newMediaItems = [];

    const reqHeaders = new HttpHeaders({
        Authorization: 'Bearer '+ authToken,
        'Content-type': 'application/octet-stream',
        'X-Goog-Upload-Content-Type': uploadedFile.type,
        'X-Goog-Upload-File-Name': uploadedFile.name,
        'X-Goog-Upload-Protocol': 'raw'
      })
    

      const batchCreateHeaders = new HttpHeaders({
        Authorization: 'Bearer '+ authToken,
        'Content-type': 'application/json'
      })
    
    let uploadToken = await this.http.post(
      'https://photoslibrary.googleapis.com/v1/uploads',
      body, {headers: reqHeaders, responseType: 'text'}).toPromise(); 

      // uploadToken.tap(res => {
    newMediaItems.push(
          {
            description: uploadedFile.description,
            simpleMediaItem: {
              fileName: uploadedFile.name,
              uploadToken: uploadToken
            }
          });

      return this.http.post(
            'https://photoslibrary.googleapis.com/v1/mediaItems:batchCreate',
            { albumId: id, newMediaItems }, {headers: batchCreateHeaders}).toPromise();

    // return Parse.Cloud.run('uploadPhoto', { id, uploadedFile })

  }
}

